import isContactAutoAnswer from 'lib/common/utils/connect/isContactAutoAnswer';
import connectAction from 'lib/common/utils/connectAction';
import connectGetter from 'lib/common/utils/connectGetter';

import { isConference } from '../../../utils/conferenceConnections';
import isAgentSupervising from '../../../utils/connect/isAgentSupervising/isAgentSupervising';

export default function handleContactAutoAnswer(
  contact: connect.Contact,
  { hasMicrophonePermission, agent }: { hasMicrophonePermission: boolean; agent: connect.Agent | null }
): void {
  const contactType = connectGetter(contact, 'getType');
  const isVoice = contactType === connect.ContactType.VOICE;
  const isDisabledCall = !hasMicrophonePermission && isVoice;
  const hasConnectVoiceAutoAnswer = connectGetter(agent, 'getConfiguration')?.softphoneAutoAccept && isVoice;

  if (
    isDisabledCall ||
    hasConnectVoiceAutoAnswer ||
    isAgentSupervising(contact) ||
    !isContactAutoAnswer(contact) ||
    isConference(contact)
  ) {
    return;
  }

  // The incoming banner will disable the accept/reject buttons if auto answer is on, so we can do this without waiting for it
  connectAction('accept', contact, { ignoreError: true });
}
